/* Gün içi saat. `?saat=14` (ya da `?saat=14:30`) ile prova için sabitlenebilir. */

import { useEffect, useState } from "react";

/** "09:38" → 578 */
export const toMin = (time: string): number => {
  const [h, m] = (time || "0:0").split(":").map(Number);
  return (h || 0) * 60 + (m || 0);
};

const nowMinutes = (): number => {
  const d = new Date();
  return d.getHours() * 60 + d.getMinutes();
};

function override(): number | null {
  if (typeof window === "undefined") return null;
  const raw = new URLSearchParams(window.location.search).get("saat");
  if (raw == null) return null;
  const [h, m] = raw.split(":").map(Number);
  if (!Number.isFinite(h) || h < 0 || h > 23) return null;
  return h * 60 + (Number.isFinite(m) ? m : 0);
}

/** Dakika cinsinden şu an; dakikada bir tazelenir. */
export function useClock(): number {
  const fixed = override();
  const [now, setNow] = useState(() => fixed ?? nowMinutes());

  useEffect(() => {
    if (fixed != null) return;
    const timer = setInterval(() => setNow(nowMinutes()), 60000);
    return () => clearInterval(timer);
  }, [fixed]);

  return fixed ?? now;
}
